import { Grid } from '@mui/material';
import React from 'react';
import jayeensProfile from '../../../../Images/JAYEEN-BIN-ALAM-ROOTDEVS.webp';
import './Banner.css';
// import Typewriter from 'typewriter-effect';
import { HashLink } from 'react-router-hash-link';

const Banner = () => {
    return (
        <section className="banner-section">
            <Grid container>
                <Grid item xs={12} md={6}>
                    <div className="banner-left">
                        <div className='image-container'>
                            <img src={jayeensProfile} alt="MD. Jayeen Bin Alam" />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} md={6}>
                    <div className="banner-right" >
                        {/* <Typewriter
                            options={{
                                strings: ['JavaScript developer', 'Wordpress expert'],
                                autoStart: true,
                                loop: true,
                            }}
                        /> */}
                        <h1>MD. Jayeen Bin Alam</h1>
                        <p style={{ color: '#BBB', fontWeight: '400' }}>JavaScript developer since 2021 with experience across frontend and backend development. I’ve built
                            web applications, automation tools using Puppeteer, and bots for Discord and Telegram. I also work
                            with Web3 integrations, connecting applications with smart contracts. Alongside development, I have
                            a foundational understanding of computer networking.</p>
                        <div className="banner-right-btns">
                            <a href='https://drive.google.com/uc?id=1DuR6bwZw5CqeZGFLXshKqTuARWpT_08G&export=download' className="jbuttonPremium" target="_blank" rel="noreferrer" download>Download resume</a>
                            <HashLink to='/#contact-form' className="jbutton">Contact</HashLink>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </section>
    );
};

export default Banner;